<template>
    <div class="email-card">
        <template-card-v2 :oneLog="oneLog" :linkedtype="linkedtype" :linkedid="linkedid">
            <template #icon>
                <CompassObject
                    v-if="emailStatus.includes(oneLog.email.status)"
                    object="sent-email"
                    size="small"
                />
                <CompassObject
                    v-else-if="['replied', 'received'].includes(oneLog.email.status)"
                    object="inbox-email"
                    size="small"
                />
            </template>

            <template #label v-if="['replied', 'received'].includes(oneLog.email.status)">
                <span
                    v-if="oneLog.email.from"
                    class="semibold gray-80 fs-2 email-card-status-sender__label"
                >
                    {{ $l10n.__('De : %(emailSender)s', { emailSender: oneLog.email.from.email }) }}
                </span>
            </template>
            <template #label v-else-if="oneLog.owner">
                <div class="flex-row">
                    <person-list-light :list="[oneLog.owner]"></person-list-light>
                    <div
                        v-if="hasStatusConfig"
                        class="flex-level wp-10 ml-2 email-card-status__container"
                    >
                        <CompassIcon
                            :type="getStatusConfig.iconColor"
                            size="extra-small"
                            :icon="getStatusConfig.icon"
                        ></CompassIcon>
                        <span :class="'ml-1 fs-2 ' + getStatusConfig.color">
                            {{ getStatusConfig.label }}
                        </span>
                    </div>
                </div>
            </template>

            <template #content>
                <div>
                    <span
                        v-if="oneLog.email.subject"
                        class="typographies-paragraph-medium-semibold email-card-title"
                        @click="mailPreview(oneLog)"
                    >
                        {{ sanitizeQuotes(oneLog.email.subject) }}
                    </span>
                    <p
                        class="typographies-paragraph-medium-regular email-card__content"
                        v-html="sanitizeQuotes(oneLog.email.description)"
                    ></p>
                </div>
            </template>
        </template-card-v2>

        <CompassDialog
            :visible.sync="cancelModal"
            size="small"
            :title="$t.__('common.actions.cancel_sending_email')"
        >
            <template #default>
                <div class="dialog__default">
                    <p class="typographies-paragraph-medium-regular">
                        {{
                            $l10n.__(
                                "Confirmez-vous vouloir annuler l'envoi de cet email programmé ?",
                            )
                        }}
                    </p>
                    <ul class="typographies-paragraph-medium-regular">
                        <li>- {{ $l10n.__('Le destinataire ne recevra jamais cet email.') }}</li>
                        <li>- {{ $l10n.__('Il n’apparaitra plus dans l’activité') }}</li>
                        <li>- {{ $l10n.__('Ceci est une action définitive.') }}</li>
                    </ul>
                </div>
            </template>
            <template #footer>
                <div class="dialog__footer">
                    <CompassButton
                        :label="$t.__('common.actions.cancel')"
                        type="secondary"
                        @click="cancelModal = false"
                    />
                    <CompassButton
                        :label="$t.__('common.actions.confirm_cancel_sending')"
                        type="primary"
                        class="ml-3"
                        @click="cancelMail(oneLog)"
                    />
                </div>
            </template>
        </CompassDialog>
    </div>
</template>

<script>
import TemplateCardV2 from './TemplateCardV2.vue';
import TimelineCardMixin from './TimelineCardMixin.js';
import PersonListLight from 'vcomponents/utilities/PersonListLight.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateUser } = createNamespacedHelpers('user');

export default {
    components: {
        TemplateCardV2,
        PersonListLight,
    },
    mixins: [TimelineCardMixin],
    data() {
        return {
            lang: this.$parent.lang,
            cancelModal: false,
            availableStatusConfig: [
                {
                    icon: 'clock-fill',
                    label:
                        this.$l10n.__('Programmé le') +
                        ` ${moment.unix(this.oneLog.timestamp).format('DD MMMM YYYY HH:mm')}`,
                    color: 'gray-60',
                    iconColor: 'warning',
                    status: 'scheduled',
                },
                {
                    icon: 'success-circle-fill',
                    label: this.$l10n.__('Email ouvert'),
                    color: 'gray-60',
                    iconColor: 'success',
                    status: 'opened',
                },
            ],
            emailStatus: [
                'scheduled',
                'automation',
                'dunning',
                'deleted',
                'updated',
                'unlinked',
                'linked',
                'opened',
                'dropped',
                'bounced',
                'delivered',
                'toggleread',
                'failed',
                'restored',
                'sent',
                'created',
            ],
        };
    },
    created() {
        EventBus.on('timeline:linkEmail', this.linkEmail);
        EventBus.on('timeline:cancelSendEmail', this.showCancelModal);
    },
    destroyed() {
        EventBus.on('timeline:linkEmail', this.linkEmail);
        EventBus.off('timeline:cancelSendEmail', this.showCancelModal);
    },
    computed: {
        ...mapStateUser({
            userForename: 'forename',
            userName: 'name',
        }),
        getStatusConfig() {
            return this.oneLog.email.isOpen && this.oneLog.email.status === 'sent'
                ? this.availableStatusConfig.find((config) => config.status === 'opened')
                : this.availableStatusConfig.find(
                      (config) => config.status === this.oneLog.email.status,
                  );
        },
        hasStatusConfig() {
            return !_.isNil(this.getStatusConfig);
        },
    },
    methods: {
        sanitizeQuotes(text) {
            return text
                ? text.replaceAll("''", "'").replaceAll("\\'", "'").replaceAll('\\"', '"')
                : '';
        },
        mailPreview(mail) {
            if (mail.email.provider === 'nylas') {
                if (!mail.email.threadId) {
                    EmailBox.preview(mail.objectid);
                } else if (mail.isMine) {
                    EmailBox.view(mail.email.threadId, undefined, mail.eventDetails.message_id);
                } else {
                    EmailBox.preview(
                        mail.email.threadId,
                        undefined,
                        mail.owner ? mail.owner.id : undefined,
                        mail.eventDetails.message_id,
                    );
                }
            } else if (mail.email.provider === 'sendgrid') Email.view(mail.objectid);
        },
        cancelMail(mail) {
            if (mail.email.provider === 'nylas')
                axios
                    .post('/?_f=emailBox', {
                        action: 'delete',
                        id: mail.objectid,
                        type: 'scheduled',
                    })
                    .then(() => (this.cancelModal = false));
            else if (mail.email.provider === 'sendgrid')
                axios
                    .post('/?_f=email', { action: 'moveToTrash', emailid: mail.objectid })
                    .then(() => (this.cancelModal = false));
        },

        linkEmailForm(ids) {
            if (ids.length === 0) {
                return;
            }
            EmailHelper.openLinkForm(ids, () =>
                EventBus.emit('timeline:refreshLog', {
                    objectType: this.oneLog.objecttype,
                    objectId: this.oneLog.objectid,
                }),
            );
        },
        linkEmail(mail) {
            this.linkEmailForm([mail.params[0].email.threadId ?? mail.objectid]);
        },
        showCancelModal(mail) {
            if (mail.objectid === this.oneLog.objectid) {
                this.cancelModal = true;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.email-card {
    .dialog {
        &__default {
            padding-bottom: 24px;
            p {
                margin: 0 0 var(--spacing-3);
            }
            ul {
                margin: 0;
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
    &-title {
        cursor: pointer;
    }
    &__content {
        margin: var(--spacing-0) 0 0;
    }
    &-status__container span,
    &-status-sender__label span {
        line-height: 16px;
    }
}
</style>
